/**
 * Service and Context-specific Icon Collections
 */

import {
  FEATURE_ICONS,
  BUSINESS_ICONS,
  TECHNICAL_ICONS,
  CONTENT_ICONS,
  STATUS_ICONS,
} from "./iconConstants";

// SERVICE ICONS - Used for main service categories on About/Overview pages
export const SERVICE_ICONS = {
  // Search & Discovery Services
  SEARCH_DISCOVERY: "🔍",
  COMPREHENSIVE_SEARCH: "🔍",
  DISCOVERY: "🔍",
  EXPLORATION: "🔍",

  // Creation & Design Services
  CREATION_DESIGN: "🎨",
  CREATIVE_SUITE: "🎨",
  DESIGN_STUDIO: "🎨",
  ARTISTIC_CREATION: "🎨",

  // Protection & Monitoring Services
  PROTECTION_MONITORING: "🛡️",
  IP_PROTECTION: "🛡️",
  SECURITY_SHIELD: "🛡️",
  MONITORING_GUARD: "🛡️",

  // Trading & Monetization Services
  TRADING_MONETIZATION: "💰",
  BUSINESS_TRADING: "💰",
  REVENUE_GENERATION: "💰",
  MONETIZATION: "💰",
  MARKETPLACE: "💰",
};

/**
 * Icons commonly used in product feature listings
 */
export const PRODUCT_FEATURE_ICONS = {
  COMPREHENSIVE_SEARCH: FEATURE_ICONS.SEARCH,
  REALTIME_MONITORING: FEATURE_ICONS.LIGHTNING,
  AI_ANALYSIS: FEATURE_ICONS.ROBOT,
  DETAILED_REPORTS: FEATURE_ICONS.BAR_CHART,
  TARGETED_RESULTS: FEATURE_ICONS.TARGET,
  CREATIVE_DESIGN: FEATURE_ICONS.PALETTE,
  LEGAL_COMPLIANCE: FEATURE_ICONS.SCALE,
  DATA_ANALYTICS: FEATURE_ICONS.CHART,
  BUSINESS_TOOLS: BUSINESS_ICONS.BRIEFCASE,
  PROFESSIONAL_PLANNING: BUSINESS_ICONS.CLIPBOARD,
  PROFESSIONAL_QUALITY: CONTENT_ICONS.GOLD_MEDAL,
  PREMIUM_QUALITY: CONTENT_ICONS.DIAMOND,
  EXCELLENCE: CONTENT_ICONS.TROPHY,
};

/**
 * Icons for business and commercial contexts
 */
export const BUSINESS_CONTEXT_ICONS = {
  PRICING: BUSINESS_ICONS.MONEY,
  PROFESSIONAL_SERVICE: BUSINESS_ICONS.BRIEFCASE,
  STRATEGIC_PLANNING: BUSINESS_ICONS.CLIPBOARD,
  VISION_MONITORING: BUSINESS_ICONS.EYE,
  GROWTH_STRATEGY: FEATURE_ICONS.ROCKET,
  PERFORMANCE_ANALYTICS: FEATURE_ICONS.BAR_CHART,
};

/**
 * Icons for technical documentation and API references
 */
export const TECHNICAL_CONTEXT_ICONS = {
  API_ENDPOINT: TECHNICAL_ICONS.PACKAGE,
  CONFIGURATION: TECHNICAL_ICONS.WRENCH,
  SECURITY: TECHNICAL_ICONS.LOCK,
  PERFORMANCE: FEATURE_ICONS.LIGHTNING,
  SEARCH_API: FEATURE_ICONS.SEARCH,
  DATA_PROCESSING: FEATURE_ICONS.BAR_CHART,
  DESIGN_API: FEATURE_ICONS.PALETTE,
  AUTHENTICATION: TECHNICAL_ICONS.LOCK,
};

/**
 * Icons for content and article sections
 */
export const CONTENT_CONTEXT_ICONS = {
  KEY_TAKEAWAYS: FEATURE_ICONS.TARGET,
  IMPORTANT_STEP: TECHNICAL_ICONS.WRENCH,
  HIGHLIGHT: CONTENT_ICONS.STAR,
  TIP: CONTENT_ICONS.BULB,
  WARNING: STATUS_ICONS.WARNING,
  SUCCESS: STATUS_ICONS.CHECK,
  MAGIC_CONCEPT: CONTENT_ICONS.CRYSTAL_BALL,
  ACHIEVEMENT: CONTENT_ICONS.TROPHY,
};

/**
 * Icons for main service categories (About page, overview sections)
 */
export const SERVICE_CATEGORY_ICONS = {
  SEARCH_DISCOVERY: SERVICE_ICONS.SEARCH_DISCOVERY,
  CREATION_DESIGN: SERVICE_ICONS.CREATION_DESIGN,
  PROTECTION_MONITORING: SERVICE_ICONS.PROTECTION_MONITORING,
  TRADING_MONETIZATION: SERVICE_ICONS.TRADING_MONETIZATION,
};
